import { render, staticRenderFns } from "./MagazzinoArticoliStoricoContabileComponent.vue?vue&type=template&id=3ce5da7a"
import script from "./MagazzinoArticoliStoricoContabileComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliStoricoContabileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports